const isExternalLink = true

export const businessLinks = [
  {
    id: 'retail',
    anchorImgPath: '/images/business-retail-links.svg',
    title: '流通小売事業',
    engTitle: 'Distribution Retail',
    titleImgPath: '/images/business-retail.svg',
    businessContent: (
      <>
        <p>
          トライアルは『あなたの「生活必需店」。』を、西友は『「西友が身近にあるしあわせ」をめざして』を使命とし、挑戦を続けております。さらに、当社グループの統合ビジョンとして「買い物を楽しく、暮らしを豊かに。」を掲げ、新しい価値をお客さまへお届けしてまいります。
        </p>
        <p>出店フォーマットは、小型から大型まで多岐に渡り、日本全国に店舗を展開しております。</p>
        <p>
          商品ラインナップは、食品（特に生鮮食品）に注力しており、こだわりのおいしさを追求しております。非食品は生活用品やハード用品を取り扱っております。
        </p>
        <p>
          価格戦略は、EDLP（Every Day Low Price）を基本方針としており、競争力ある価格提案を行っております。
        </p>
      </>
    ),
    companies: [
      {
        link: 'https://trial-holdings.inc/',
        imgPath: '/images/OurBusiness_logo_TRIAL holdings.webp',
        name: '株式会社トライアルホールディングス（持株会社）',
        isExternalLink,
      },
      {
        link: 'https://www.trial-net.co.jp/',
        imgPath: '/images/cardlink-logo-traial.webp',
        name: '株式会社トライアルカンパニー',
        isExternalLink,
      },
      {
        imgPath: '/images/business_retail_dummy.svg',
        name: '株式会社トライアルストアーズ',
      },
      {
        imgPath: '/images/Logo_TRIALGO_1L_1.png',
        name: '株式会社トライアルGO',
      },
      {
        imgPath: '/images/business_retail_dummy.svg',
        name: '株式会社魚寅',
      },
      {
        link: 'https://www.seiyu.co.jp/',
        imgPath: '/images/business_SEIYU.png',
        name: '株式会社西友',
        isExternalLink,
      },
      {
        imgPath: '/images/business_retail_dummy.svg',
        name: '株式会社西友プロキュアメント',
      },
      {
        imgPath: '/images/business_retail_dummy.svg',
        name: '株式会社西友サービス',
      },
      {
        imgPath: '/images/business_TRIAL_Supercenter.png',
        name: '株式会社トライアルスーパーセンター',
      },
      {
        imgPath: '/images/business_RIALT.png',
        name: '株式会社RIALT',
      },
      {
        link: 'https://meijiya-kohaku.co.jp/',
        imgPath: '/images/business_meijiya.png',
        name: '株式会社明治屋',
        isExternalLink,
      },
      {
        imgPath: '/images/business_kohaku_hompo.png',
        name: '株式会社こはく本舗',
      },
      {
        imgPath: '/images/business_retail_dummy.svg',
        name: '株式会社トライアルフードパーク',
      },
      {
        link: 'https://www.tls-net.co.jp/',
        imgPath: '/images/business-tls.webp',
        name: '株式会社MLS',
        isExternalLink,
      },
      {
        link: 'https://su-pay.jp/',
        imgPath: '/images/OurBusiness_logo_SU-PAY.webp',
        name: '株式会社SU-PAY',
        isExternalLink,
      },
      {
        link: 'https://trialcars.co.jp/',
        imgPath: '/images/business_trial_cars.svg',
        name: '株式会社トライアルカーズ',
        isExternalLink,
      },
      {
        imgPath: '/images/business_retail_dummy.svg',
        name: '株式会社トライアル・インシュアランス・サービス',
      },

      {
        imgPath: '/images/business_retail_dummy.svg',
        name: 'TRIAL.Korea Co.,Ltd.（関連会社）',
      },
      {
        imgPath: '/images/business_retail_dummy.svg',
        name: 'F&G Retail Co.,Ltd.（関連会社）',
      },
    ],
  },
  {
    id: 'retail-ai',
    anchorImgPath: '/images/business-retail-ai-links.svg',
    title: 'リテールAI事業',
    engTitle: 'Retail AI',
    titleImgPath: '/images/business-retail-ai.svg',
    businessContent: (
      <p>
        「テクノロジーによって、新時代のお買い物体験を生み出し、流通の仕組みを革新する」をビジョンとして、IoTデバイスを活用した各種ソリューションやソフトウェアサービスを提供しております。
        <br />
        Skip Cart等の開発を通じて、お客様に新しい買い物体験を提供するとともに、CPG（消費財）メーカーとの協働やデータの活用によって流通業界に多く存在している「ムダ・ムラ・ムリ」の削減を目指しています。
      </p>
    ),
    companies: [
      {
        path: 'http://www.trechina.com/',
        imgPath: '/images/business_TRIAL_Technology.png',
        name: '株式会社トライアルテクノロジー',
        isExternalLink,
      },
      {
        link: 'https://www.retail-ai.jp/',
        imgPath: '/images/cardlink-logo-retail-ai.svg',
        name: '株式会社Retail AI',
        isExternalLink,
      },
      {
        path: 'http://www.trechina.com/',
        imgPath: '/images/business_retail_ai_dummy.svg',
        name: '拓锐安（上海）科技有限公司',
        isExternalLink,
      },
      {
        path: 'http://www.trechina.com/',
        imgPath: '/images/business_tre_china.png',
        name: '烟台创迹软件有限公司',
        isExternalLink,
      },
      {
        path: 'http://www.trechina.com/',
        imgPath: '/images/business_retail_ai_dummy.svg',
        name: '上海翔迹企业管理有限公司',
        isExternalLink,
      },
      {
        path: 'http://www.trechina.com/',
        imgPath: '/images/business_TRYU.png',
        name: '株式会社TRYU',
        isExternalLink,
      },
      {
        link: 'https://salesplus.co.jp/',
        imgPath: '/images/sales-plus-logo.webp',
        name: '株式会社SalesPlus（関連会社）',
        isExternalLink,
      },
      {
        link: 'https://www.retail-cix.jp/',
        imgPath: '/images/Logo_Retail-CIX.png',
        name: '株式会社RetailｰCIX（関連会社）',
        isExternalLink,
      },
      {
        imgPath: '/images/business_retail_dummy.svg',
        name: 'GALILEI Media株式会社（関連会社）',
      },
    ],
  },
  {
    id: 'others',
    anchorImgPath: '/images/business-other-links.svg',
    title: 'その他',
    engTitle: 'Other Business',
    titleImgPath: '/images/business-other.svg',
    businessContent: (
      <p>
        不動産の所有・活用及び旅館業や、こだわりの料理を提供する料亭などの飲食業、ゴルフ場運営などのリゾート関連事業を行っております。
      </p>
    ),
    companies: [
      {
        link: 'https://trial-realestate.co.jp/',
        imgPath: '/images/business_TRIAL_Real_Estate.png',
        name: '株式会社トライアルリアルエステート',
        isExternalLink,
      },
      {
        link: 'https://ted-trial-net.co.jp/',
        imgPath: '/images/business_TRIAL_Estate_Development.png',
        name: '株式会社トライアル開発',
        isExternalLink,
      },
      {
        link: 'https://www.kawamurasatodesign.com/',
        imgPath: '/images/business-kawamura.webp',
        name: '株式会社河村佐藤デザイン',
        isExternalLink,
      },
      {
        link: 'https://trial-golf-resort-wakamiya-course.com/',
        imgPath: '/images/business_TRIAL_Golf_Resort.png',
        name: '株式会社トライアルゴルフ&リゾート',
        isExternalLink,
      },
      {
        link: 'https://trial-golf-resort-aso-course.com/',
        imgPath: '/images/business_TGR_Aso.png',
        name: '株式会社ティージーアール阿蘇',
        isExternalLink,
      },
      {
        link: 'https://trial-golf-resort-oita-course.com/',
        imgPath: '/images/business_TGR_Oita.png',
        name: '株式会社ティージーアール大分',
        isExternalLink,
      },
      {
        imgPath: '/images/business_trial_tours_dummy.svg',
        name: '株式会社トライアルツアーズ',
      },
      {
        imgPath: '/images/business_others_dummy.svg',
        name: '株式会社トライアルヒューマンベース',
      },
      {
        imgPath: '/images/business_others_dummy.svg',
        name: '株式会社トライアルベネフィット',
      },
      {
        imgPath: '/images/business_others_dummy.svg',
        name: '株式会社トライアルチャレンジド',
      },
      {
        imgPath: '/images/business_others_dummy.svg',
        name: '株式会社Fieldman',
      },
    ],
  },
]
